<template>
  <div>
    <el-radio
      v-model="flex"
      label="1"
      border
    >
      横向滚动
    </el-radio>
    <el-radio
      v-model="flex"
      label="2"
      border
    >
      纵向滚动
    </el-radio>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SpFlex',
  mixins: [mixin],
  props: {},
  data () {
    return {
      flex: '1'
    }
  },

  methods: {}
}
</script>

<style scoped lang="scss"></style>
